






























import { dateFromIsoString, humanizeIsoTime } from 'plankton'

export default {
  props: {
    stop: { type: Object, required: true },
    mapsURL: { type: String, required: true },
    startTime: { type: String, default: null },
    endTime: { type: String, default: null }
  },
  computed: {
    day() {
      return dateFromIsoString(this.startTime)
    },
    startHour() {
      return humanizeIsoTime(this.startTime)
    },
    endHour() {
      return humanizeIsoTime(this.endTime)
    }
  }
}
